import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { COMPANY, SERVICES, SERVICE_PAGES } from "@/lib/site-data";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/5 bg-[#0A0C0F]">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <Logo size={40} />
            <span className="leading-tight">
              <span className="block font-serif text-base font-semibold text-white">NB</span>
              <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-slate-400">Couverture</span>
            </span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            Couvreurs-zingueurs à Bordeaux depuis 1999. L’art de la couverture au service des toits de la Gironde.
          </p>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-terra">Contact</h4>
          <ul className="mt-5 space-y-3 text-sm text-slate-300">
            <li>
              <a href={COMPANY.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-3 transition-colors hover:text-terra">
                <Phone className="h-4 w-4 shrink-0 text-terra" />
                {COMPANY.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${COMPANY.email}`} data-testid="footer-email-link" className="flex items-center gap-3 transition-colors hover:text-terra">
                <Mail className="h-4 w-4 shrink-0 text-terra" />
                {COMPANY.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-terra" />
              {COMPANY.address}
            </li>
            <li className="flex items-start gap-3">
              <Clock className="mt-0.5 h-4 w-4 shrink-0 text-terra" />
              {COMPANY.hours}
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-terra">Services</h4>
          <ul className="mt-5 space-y-2.5 text-sm text-slate-400">
            {SERVICES.map((s) => {
              const sp = SERVICE_PAGES.find((p) => p.serviceId === s.id);
              return (
                <li key={s.id}>
                  <a href={sp ? `/services/${sp.slug}` : "#services"} data-testid={`footer-service-${s.id}`} className="transition-colors hover:text-terra">{s.title}</a>
                </li>
              );
            })}
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-terra">Navigation</h4>
          <ul className="mt-5 space-y-2.5 text-sm text-slate-400">
            <li><a href="#realisations" className="transition-colors hover:text-terra">Réalisations</a></li>
            <li><a href="#savoir-faire" className="transition-colors hover:text-terra">Savoir-faire</a></li>
            <li><a href="#zones" className="transition-colors hover:text-terra">Zones d’intervention</a></li>
            <li><a href="#devis" className="transition-colors hover:text-terra">Devis gratuit</a></li>
            <li><a href="#faq" className="transition-colors hover:text-terra">FAQ</a></li>
            <li><a href="/conseils" data-testid="footer-blog-link" className="transition-colors hover:text-terra">Conseils toiture</a></li>
            <li><a href="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-terra">Espace pro</a></li>
            <li><a href="/mentions-legales" data-testid="footer-legal-link" className="transition-colors hover:text-terra">Mentions légales</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-6 py-6 text-xs text-slate-500">
          <p>© 2026 {COMPANY.name} — Tous droits réservés</p>
          <p className="font-mono tracking-wider">Garantie décennale & RC Pro</p>
        </div>
      </div>
    </footer>
  );
}
